export default __webpack_public_path__ + "static/media/errorwindow.d42fba42.svg";